import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import AreaChart from "../../components/static/Admindashboard/AreaChart";
import PieChart from "../../components/static/Admindashboard/PieChart";
import Alluser from "../../components/static/Admindashboard/Alluser";
import KycStatus from "../../components/static/Admindashboard/KycStatus";
import UserWatchlists from "../../components/static/Admindashboard/UserWatchlists";
import UserPortfolios from "../../components/static/Admindashboard/UserPortfolios";
import AdminUserDetails from "../../components/static/Admindashboard/AdminUserDetails";
import ProductList from "../../components/static/Product/ProductList";
import ProductQuantity from "../../components/static/Product/ProductQuantity";

import ProductChart from "../../components/static/Product/ProductChart";
import Posts from "../../components/static/Adminblog/Posts";
import Categories from "../../components/static/Adminblog/Categories";
import Blogtags from "../../components/static/Adminblog/Blogtags";
import Blogstats from "../../components/static/Adminblog/Blogstats";
import AdminProfile from "../../components/static/Admindashboard/AdminProfile";
import ExpertList from "@/components/static/Admindashboard/ExpertList";
import AppointmentList from "@/components/static/Admindashboard/AppointmentList";
import CreateExpert from "@/components/static/Admindashboard/CreateExpert";
import ReferralList from "@/components/static/Referal/Referralslist";
import UserWallet from "@/components/static/Admindashboard/UserWallet";
import AdminWallet from "../../components/static/Admindashboard/AdminWallet";
import AdminWalletManagement from "../../components/static/Admindashboard/AdminWallet_management";

import TransactionsList from "@/components/static/Admindashboard/TransactionList";
import ContentGallery from "@/components/static/Admindashboard/Allpost";
import AdminCreateEntity from "../../components/static/auth/AdminCreateEntity";
import FilterList from "@/components/static/Admindashboard/FilterList";
import ContentUploadForm from "@/components/static/Admindashboard/createpost";

import ReferralStats from "@/components/static/Referal/Referralsstats";
import { useAuth } from "@/hooks/useAuth";
import MutualFund from "@/components/static/Admindashboard/MutualFund";
import AdminContact from "@/components/static/Admindashboard/AdminContact";
import AdminNotifications from "@/components/static/Admindashboard/AdminNotifications";
import { useNotification } from "@/contexts/notification/NotificationContext";
import AdminHoldingsDashboard from "@/components/static/Admindashboard/AdminHoldingsDashboard";
import AdminApprovalDashboard from "@/components/static/Admindashboard/AdminApprovalDashboard";
import ProductSell from "@/components/static/Product/ProductSell";
import AdminSupport from "@/components/static/Admindashboard/AdminSupport";
import AsperoLogs from "./AsperoLogs";
import AsperoWebhookDashboard from "./AsperoWebhookDashboard";
import AsperoBondInvestments from "./AsperoBondInvestments";

import AdminLayout from "../../layouts/AdminLayout";

const SidebarLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const getSectionFromPath = useCallback(() => {
    const path = location.pathname;
    const segment = path.startsWith("/admindashboard")
      ? path.split("/").filter(Boolean)[1]
      : null;
    return segment;
  }, [location.pathname]);

  const [currentSection, setCurrentSection] = useState("all-users");

  useEffect(() => {
    const section = getSectionFromPath();
    if (!section) {
      navigate("/admindashboard/all-users", { replace: true });
    } else {
      setCurrentSection(section);
    }
  }, [getSectionFromPath, navigate]);

  const renderSectionContent = () => {
    switch (currentSection) {
      case "dashboard":
        return <AreaChart />;
      case "admin-notifications":
        return <AdminNotifications />;
      case "calendar":
        return <PieChart />;
      case "all-users":
        return <Alluser />;
      case "Kyc-Status":
        return <KycStatus />;
      case "user-watchlists":
        return <UserWatchlists />;
      case "user-Transactions":
        return <TransactionsList />;
      case "filter-list":
        return <FilterList />;
      case "user-wallet":
        return <UserWallet />;
      case "admin-wallet":
        return <AdminWallet />;
      case "withdrawal-management":
        return <AdminWalletManagement />;
      case "user-portfolios":
        return <UserPortfolios />;
      case "user-holdings":
        return <AdminHoldingsDashboard />;
      case "user-order-request":
        return <AdminApprovalDashboard />;
      case "user-details":
        return <AdminUserDetails />;
      case "product-list":
        return <ProductList />;
      case "product-quantity":
        return <ProductQuantity />;
      case "product-sell":
        return <ProductSell />;
      case "product-chart":
        return <ProductChart />;
      case "expert-list":
        return <ExpertList />;
      case "appointment-list":
        return <AppointmentList />;
      case "blog-posts":
        return <Posts />;
      case "blog-categories":
        return <Categories />;
      case "blog-tags":
        return <Blogtags />;
      case "blog-stats":
        return <Blogstats />;
      case "create-expert":
        return <CreateExpert />;
      case "referral-list":
        return <ReferralList />;
      case "referral-stats":
        return <ReferralStats />;
      case "admin-profile":
        return <AdminProfile />;
      case "admin-settings":
        return (
          <div className="p-4 text-center">
            Admin Settings component not yet implemented
          </div>
        );
      case "admin-permissions":
        return (
          <div className="p-4 text-center">
            Admin Permissions component not yet implemented
          </div>
        );
      case "mutual-fund-list":
        return <MutualFund />;
      case "mutual-fund-analytics":
        return (
          <div className="p-4 text-center">
            Mutual Fund Analytics component not yet implemented
          </div>
        );
      case "mutual-fund-categories":
        return (
          <div className="p-4 text-center">
            Mutual Fund Categories component not yet implemented
          </div>
        );
      case "bond-list":
        return (
          <div className="p-4 text-center">
            Bond List component not yet implemented
          </div>
        );
      case "bond-analytics":
        return (
          <div className="p-4 text-center">
            Bond Analytics component not yet implemented
          </div>
        );
      case "bond-issuers":
        return (
          <div className="p-4 text-center">
            Bond Issuers component not yet implemented
          </div>
        );
      case "create-post":
        return (
          <div className="p-4 text-center">
            <ContentUploadForm />
          </div>
        );
      case "all-posts":
        return <ContentGallery />;
      case "contact-data":
        return <AdminContact />;
      case "contact-support":
        return <AdminSupport />;
      case "aspero-logs":
        return <AsperoLogs />;
      case "aspero-dashboard":
        return <AsperoWebhookDashboard />;
      case "aspero-investments":
        return <AsperoBondInvestments />;
      default:
        return <div>Select a section</div>;
    }
  };

  return (
    <AdminLayout>
        {renderSectionContent()}
    </AdminLayout>
  );
};

export default SidebarLayout;
